export default __webpack_public_path__ + "static/illustration-girl-bench-2f9c4e30ac2b648099e5d7264f255db5.svg";